import React from 'react'
import PropTypes from 'prop-types'
import { HelmetDatoCms } from 'gatsby-source-datocms'

import { MainContentWrapper } from './styles.js'

import { general } from '@content/general'
import shareImage from '@images/fb-share.jpg'

const Main = ({ seo, path, transitionStatus, children }) => {
  const filteredTags = { tags: seo.tags.filter(n => n) }

  return (
    <MainContentWrapper active={transitionStatus === 'entered'}>
      <HelmetDatoCms seo={filteredTags} htmlAttributes={{ lang: 'en' }}>
        <link rel="stylesheet" href="https://use.typekit.net/hhn8tbu.css" />
        <link rel="canonical" href="https://ideolo.co" />
      </HelmetDatoCms>
      {children}
    </MainContentWrapper>
  )
}

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

export default Main
